import React from "react";
import "./QueMeLogo.css";

const LOGOS = {
  primary: "/01_Primary_Horizontal/QueMe_Primary_Horizontal_Transparent.png",
  stacked: "/02_Stacked/QueMe_Stacked_Transparent.png",
  icon: "/03_Icon_App_Favicon/QueMe_Icon_256px.png",
  brand: "/04_Brand_Colour/QueMe_Brand_Colour_Transparent.png",
  reversed: "/05_Reversed_Dark/QueMe_Reversed_Dark.png",
  "mono-black": "/06_Monochrome/QueMe_Monochrome_Black_Transparent.png",
  "mono-white": "/06_Monochrome/QueMe_Monochrome_White_Transparent.png",
};

const ICON_SOURCES = [16, 24, 32, 48, 64, 128, 180, 192, 256, 512, 1024];

const iconSourceForSize = (size) => {
  const numericSize = Number.parseInt(size, 10);
  if (!Number.isFinite(numericSize)) return LOGOS.icon;
  const nearest = ICON_SOURCES.reduce((best, candidate) =>
    Math.abs(candidate - numericSize) < Math.abs(best - numericSize) ? candidate : best,
  );
  return `/03_Icon_App_Favicon/${nearest === 1024 ? "QueMe_Icon_1024px.png" : `QueMe_Icon_${nearest}px.png`}`;
};

const QueMeLogo = ({ variant = "primary", className = "", alt = "QueMe", size }) => {
  const resolvedVariant = variant === "auto" ? "primary" : variant;
  const src = resolvedVariant === "icon" ? iconSourceForSize(size) : LOGOS[resolvedVariant] || LOGOS.primary;
  const isIcon = resolvedVariant === "icon";
  const style = size
    ? isIcon
      ? { width: size, height: size }
      : { height: size, width: "auto" }
    : undefined;

  return (
    <img
      src={src}
      alt={alt}
      className={`queme-logo queme-logo--${resolvedVariant} ${className}`.trim()}
      style={style}
      decoding="async"
    />
  );
};

export { LOGOS };
export default QueMeLogo;
